import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { AIFC_ONBOARDING_STATE_KEYS } from '../../constants/onboarding-state/onboarding-afic-onboarding.ts';

import { getOnboardingStateGQL } from './OnboardingStatus.graphql.ts';

export const preloadAIFCOnboardingStateForTopNav = () => {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: getOnboardingStateGQL,
		variables: {
			key: [...Object.values(AIFC_ONBOARDING_STATE_KEYS)],
		},
	});
};
